import { apiV2 } from "../axiosInstance";

function getSubSegments(segmentNumber) {
    return apiV2.get(`subsegments/segment/${segmentNumber}`);
};

export { getSubSegments }